import { splitsForNav } from '@nebula/navigation';

export default {
  ...splitsForNav,
  applePay: 'prodMove-applePay-UpdateYourPaymentDetails',
  breachPlus: 'BreachPlus',
  prodmoveDD: 'ProdmoveDirectDebit',
  fullCreditReportIdPlus: 'ceoc-full-report-id-plus',
  fullCreditReportBreachPlus: 'ceoc-full-report-breach-plus',
  fullCreditReportBreach: 'ceoc-full-report-breach',
  fullCreditReportFree: 'ceoc-full-report-free',
  productMovementBreachExtension: 'product-movement-breach-extension',
  protectWebRollout: 'protect-web-rollout',
  applePayWebRollout: 'applepay-web-rollout',
  googlePayWebRollout: 'googlepay-web-rollout',
  AvatarProfileMPVExperience: 'web-profile-new-experience',
  debugRecurlyThreeDs: 'debug-recurly-threeds',
  disableApplePayRecurly: 'disable-applepay-recurly',
  disableSavedPaymentMethod: 'prodmove-disable-saved-payment-methods',
  billingDeclineIncidentJuly25: 'billing-decline-incident-july25',
  disableGooglePayRecurly: 'disable-googlepay-recurly',
  disableGooglePayOnAndroid: 'disable-googlepay-on-android',
  webNewChangePaymentMethod: 'web-new-change-payment-method',
  webChangeBillingDate: 'web-change-billing-date',
  flutterCbdToggle: 'flutter-cbd-toggle',
  idDownsellRetention: 'prodmove-id-downsell-retention',
  cancelSubscriptionCoolOff: 'cancel-subscription-cool-off',
  deactivateAccountCoolOff: 'deactivate-account-cool-off',
  preventDuplicatePayment: 'prodmove-prevent-duplicate-payment',
  annualPricing: 'identity-annual-pricing',
  webNewDeactivateAccount: 'web-new-deactivate-account',
  preventDuplicateBillingCall: 'prodmove-prevent-duplicate-bss-billing',
  isFlexSplitEnabled: 'product_flex',
  prodmoveNewDesign: 'prodmove-new-design',
  billingIncidentModalPaymentChange: 'billing-incident-modal',
};

export const defaultSplits = {
  'web-profile-new-experience': 'on',
};
